import { Schema } from 'normalizr';

import SingletonDuckEntity from './SingletonDuckEntity';

const entity = new SingletonDuckEntity(
  'customerOauthConfig', { schema: new Schema('customerOauthConfig', { idAttribute: '_id' }) }
);

export { entity };